import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface IconSnackbarData {
  message: string;
  icon: string;
  buttonLabel?: string;
}

@Component({
  selector: 'app-icon-snackbar',
  templateUrl: './icon-snackbar.component.html',
  styleUrls: ['./icon-snackbar.component.scss'],
})
export class IconSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: IconSnackbarData,
    private snackBarRef: MatSnackBarRef<IconSnackbarComponent>
  ) {}

  dismiss(): void {
    this.snackBarRef.dismissWithAction();
  }
}
